<template>
    <div class="container">
        <h1 class="mt-2">Sistemas</h1>
        <hr>
        <div class="card col-12 text-center bg-dark mt-4">
            <div class="card-body">
                <p class="card-text txC">Bienvenido!</p>
            </div>
        </div>
        <Section 
            path="/servicio" 
            title="Servicios" 
            description="Se ofrecen varios entre los cuales estan, desarrollo de aplicaicones web, moviles (nativas), programas de escritorio (java), asesorias, entre otros..."
            :image="ImageHistoria"
        />
    </div>
</template>

<script>
    import Section from './Section.vue'
    import ImageHistoria from '../../public/img/sh.png'

    export default {
        components:{
            Section
        },
        data: () =>({
            ImageHistoria
        })
    }
</script>

<style scoped>
    .txC{
        color: #FFF;
    }
</style>